// Set a cookie with a specified name, value, and expiration (in days)
export const setCookie = (name, value, minutes = 59) => {
  const stringifiedValue = JSON.stringify(value);
  const date = new Date();
  const millisToAdd = minutes * 60 * 1000; // minutes → ms
  date.setTime(date.getTime() + millisToAdd);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${stringifiedValue}; ${expires}; path=/`; // Sets the cookie at the root path
};

// Get a cookie by its name
export const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.startsWith(nameEQ)) {
      return JSON.parse(cookie.substring(nameEQ.length));
    }
  }
  return null; // If the cookie does not exist
};

// Delete a cookie by its name
export const deleteCookie = (name) => {
  setCookie(name, "", -1); // Sets the expiration to a past date
};
